const clientReceivepaymentDt = require('./clientReceivepayment-dt')
const clientReceivepaymentFullcont = require('./clientReceivepayment-fullcont')
const clientReceivepaymentMenu = require('./clientReceivepayment-menu')
const clientReceivepaymentMT = require('./clientReceivepayment-fullcont-multitable')

export function start(detail) {
      obj[detail.elem].start(detail)
}/**/

const obj = {
      dt: { start: (detail) => { clientReceivepaymentDt.start(detail) } },
      fullcont: { start: (detail) => { clientReceivepaymentFullcont.start(detail) } },
      multitable: { start: (detail) => { clientReceivepaymentMT.start(detail) } },
      menu: { start: (detail) => { clientReceivepaymentMenu.start(detail) } },
}